export default "__VITE_ASSET__CbDizpm3__"